import React, { useCallback, useEffect, useState, useRef } from "react";
import { Checkbox } from "@mui/material";
import axios from "axios";
import CommentBox from "../LeadComment/CommentBox";
import "./LeadChatbot.css";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import { AllLeadVendorComments } from "../../FetchAPI";
import { useAuth } from "../../../Store/AuthContext";
import "../LeadComment/LeadCommentModelCss.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadChatbot({ leadID }) {
  const { userID, RendomTokenfetch, userRoll } = useAuth();

  const [Comment, setComment] = useState("");
  const [showToUser, setShowToUser] = useState(false);
  const [fetchComment, setfetchComment] = useState([]);
  const [listening, setListening] = useState(false);
  const [permissionError, setPermissionError] = useState(false);
  const recognitionRef = useRef(null);

  const initRecognition = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      NotifyMessageNoReload(
        "Browser doesn't support speech recognition",
        "error"
      );
      return null;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "hi-IN";
    recognition.continuous = true;
    recognition.interimResults = true;

    recognition.onresult = (event) => {
      const results = event.results;
      const transcript = results[results.length - 1][0].transcript;
      setComment((prev) => prev + transcript);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setListening(false);

      if (event.error === "not-allowed") {
        setPermissionError(true);
        NotifyMessageNoReload(
          "Microphone access blocked. Please allow permissions.",
          "Warning"
        );
      }
    };

    recognition.onend = () => {
      setListening(false);
    };

    recognitionRef.current = recognition;
    return recognition;
  };

  const startListening = () => {
    // Reset permission error har baar try karte time
    setPermissionError(false);

    if (!recognitionRef.current) {
      const recognition = initRecognition();
      if (!recognition) return;
    }

    try {
      recognitionRef.current.start();
      setListening(true);
    } catch (error) {
      console.error("Error starting recognition:", "Warning");
      setPermissionError(true);
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      try {
        recognitionRef.current.stop();
      } catch (error) {
        console.error("Error stopping recognition:", "Warning");
      }
    }
    setListening(false);
  };

  const clearText = () => {
    setComment("");
  };

  const fetchData = useCallback(async () => {
    const data = await AllLeadVendorComments(RendomTokenfetch, leadID);
    setfetchComment(data);
  }, [RendomTokenfetch, leadID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("leadid", leadID);
    fdata.append("role_id", userRoll);
    fdata.append("comment", Comment);
    fdata.append("show_to_vendor", "1");
    if (userRoll === "5") {
      fdata.append("show_to_user", "1");
    } else {
      fdata.append("show_to_user", showToUser ? "1" : "0");
    }

    axios
      .post(`${WebsiteAPIurl}leadCommentAdd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (Comment) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.msg, "danger");
          }
          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.msg, "success");
            setComment("");
            fetchData();
            setShowToUser(false);
          }
        }
      });
  };

  return (
    <>
      <div className="TaskCommentBox">
        <div className="leadCommentaddbox">
          <form
            className="default-form "
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="form-group col-lg-12 col-md-12">
                <div className="speechbox d-flex ">
                  <label>Comments</label>
                  <div className="SpeechboxElement">
                    {!listening ? (
                      <button
                        type="button"
                        onClick={startListening}
                        style={{
                          color: permissionError ? "gray" : "#098209",
                          marginLeft: "10px",
                          fontSize: "20px",
                        }}
                        title="Start voice input"
                      >
                        <i className="fa fa-microphone" aria-hidden="true"></i>
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={stopListening}
                        style={{
                          color: "red",
                          marginLeft: "10px",
                          fontSize: "20px",
                        }}
                        title="Stop voice input"
                      >
                        <i
                          className="fa fa-microphone-slash"
                          aria-hidden="true"
                        ></i>
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={clearText}
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "20px",
                      }}
                      title="Clear text"
                    >
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <textarea
                  value={Comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add Comment"
                  rows={3}
                />
                {permissionError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    Microphone access blocked. Please allow microphone
                    permissions.
                  </div>
                )}
              </div>
              <div
                className={`col-lg-12 col-md-12  ${
                  userRoll === "5"
                    ? "text-end"
                    : "d-flex justify-content-between align-items-center"
                } mb-3`}
              >
                <div
                  className={`showtousercheckbox ${
                    userRoll === "5" ? "d-none" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                >
                  <Checkbox
                    sx={{
                      "&.Mui-checked": {
                        color: "green",
                      },
                    }}
                    checked={showToUser}
                    onChange={() => setShowToUser((prev) => !prev)}
                  />
                  <span onClick={() => setShowToUser((prev) => !prev)}>
                    Show to User
                  </span>
                </div>

                <button className="theme-btn btn-style-three submitbtn">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="commentboxdiv">
          {fetchComment.length > 0 ? (
            fetchComment.map((value, index) => (
              <CommentBox key={index} value={value} />
            ))
          ) : (
            <div className="noCommnetLead">No Comments!</div>
          )}
        </div>
      </div>
    </>
  );
}
